module.exports = __webpack_public_path__ + "img/56.163a886f.jpg";